import 'twin.macro';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ZoneId } from '@teetsh/app/src/types/zone';
import YearsSelector from '@teetsh/app/src/containers/MesAnneesScolaires/New/YearsSelector';
import FormGroup from '@teetsh/app/src/components/Form/FormGroup';
import { ZoneSelector } from '@teetsh/app/src/components/ZoneEditor/ZoneSelector';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  year?: number;
  existingYears: number[];
  zone: ZoneId;
  onChangeYear: (v: number) => void;
  onChangeZone: (v: ZoneId) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function Step1(props: Props) {
  const {
    zone,
    onChangeZone,
    onChangeYear,
    year,
    existingYears,
    onSubmit,
    onCancel,
  } = props;
  const { t } = useTranslation(['common', 'schoolyearSettings']);

  return (
    <div>
      <div tw="mb-4">
        <ZoneSelector large value={zone} onChange={onChangeZone} />
      </div>
      <div tw="mb-10">
        <FormGroup label={t('schoolyearSettings:year')}>
          <YearsSelector
            value={year}
            onChange={onChangeYear}
            existingYears={existingYears}
            zone={zone}
          />
        </FormGroup>
      </div>
      <div tw="flex justify-center space-x-4 items-center">
        <Button large minimal onClick={onCancel}>
          {t('common:buttons.cancel')}
        </Button>
        <Button
          rightIcon={ArrowRight}
          intent="primary"
          onClick={onSubmit}
          disabled={!year}
          large
        >
          {t('common:buttons.next')}
        </Button>
      </div>
    </div>
  );
}
